module.exports = __webpack_public_path__ + "img/top7_img2.3e02e185.png";